export default __webpack_public_path__ + "static/media/Face-Analysis.3d7956e6.png";